import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { Product } from '../types';
import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

const PRODUCT_TRAIT_ELIGIBILITY: Partial<Record<Product, keyof EditionAwarenessContextType>> = {
	jira: 'isEligibleForJswPremiumToTwc',
	confluence: 'isEligibleForConfluencePremiumToTwc',
};

function getProductTraitEligibility(context: EditionAwarenessContextType): boolean {
	const traitKey = PRODUCT_TRAIT_ELIGIBILITY[context.product];
	return traitKey ? Boolean(context[traitKey]) : false;
}

export function isEligibleForPremiumToTwc(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isSinglePaidApp,
		canBundleCollection,
		userRoles,
		hasDismissedButton,
		onDismissButton,
	} = context;

	return Boolean(
		isProductOneOf(product, ['jira', 'confluence']) &&
		isEditionOneOf(edition, ['premium']) &&
		getProductTraitEligibility(context) &&
		!isInTrial &&
		!isInPredunning &&
		isSinglePaidApp &&
		userRoles?.includes('SITE_ADMIN') &&
		canBundleCollection &&
		hasDismissedButton === false &&
		typeof onDismissButton === 'function' &&
		fg('premium-to-twc-upsell'),
	);
}
